<template>
  <transition name="kontak-fade">
    <div v-if="visible" class="kontak-modal-overlay" :style="{ zIndex: overlayZIndex }" @click.self="tutup">
      <div class="kontak-modal" role="dialog" aria-modal="true">
        <!-- ============================= KEPALA MODAL ============================= -->
        <div class="kontak-modal-head">
          <div>
            <h5>{{ isEdit ? "Ubah Data Kontak" : "Tambah Kontak Baru" }}</h5>
            <p>
              {{
                isEdit
                  ? "Perbarui informasi kontak yang dipilih."
                  : "Lengkapi informasi kontak baru di bawah ini."
              }}
            </p>
          </div>
          <button
            type="button"
            class="kontak-close"
            title="Tutup"
            :disabled="saving"
            @click="tutup"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>

        <!-- ============================= ISI MODAL ============================= -->
        <div class="kontak-modal-body">
          <div v-if="errorMessage" class="kontak-alert">
            <i class="fa fa-exclamation-circle"></i>
            <span>{{ errorMessage }}</span>
          </div>

          <div v-if="loadingDetail" class="kontak-loading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Memuat data kontak...</span>
          </div>

          <form
            v-else-if="!detailGagal"
            id="kontak-form-v2"
            autocomplete="off"
            @submit.prevent="simpan"
          >
            <div class="form-group">
              <label>Nama Lengkap <span class="kontak-required">*</span></label>
              <div class="row">
                <div class="col-md-6">
                  <input
                    v-model="form.first_name"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.first_name }"
                    :disabled="saving"
                    placeholder="Nama depan"
                  />
                </div>
                <div class="col-md-6">
                  <input
                    v-model="form.last_name"
                    type="text"
                    class="form-control"
                    :disabled="saving"
                    placeholder="Nama belakang (opsional)"
                  />
                </div>
              </div>
              <div v-if="errors.first_name" class="kontak-error">
                {{ errors.first_name }}
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Nomor WhatsApp <span class="kontak-required">*</span></label>
                  <input
                    v-model="form.phone_number"
                    type="tel"
                    class="form-control"
                    :class="{ 'is-invalid': errors.phone_number }"
                    :disabled="saving"
                    placeholder="Contoh: 081234567890"
                  />
                  <div v-if="errors.phone_number" class="kontak-error">
                    {{ errors.phone_number }}
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Email</label>
                  <input
                    v-model="form.email"
                    type="email"
                    class="form-control"
                    :class="{ 'is-invalid': errors.email }"
                    :disabled="saving"
                    placeholder="Contoh: nama@email.com"
                  />
                  <div v-if="errors.email" class="kontak-error">
                    {{ errors.email }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label>Tanggal Lahir</label>
              <input
                v-model="form.birth_date_data"
                type="date"
                class="form-control"
                :class="{ 'is-invalid': errors.birth_date_data }"
                :disabled="saving"
              />
              <div v-if="errors.birth_date_data" class="kontak-error">
                {{ errors.birth_date_data }}
              </div>
            </div>

            <div class="form-group">
              <label>Grup</label>
              <a-select
                v-model="selectedGroupIds"
                mode="multiple"
                show-search
                allow-clear
                option-filter-prop="children"
                placeholder="Pilih Grup"
                style="width: 100%"
                :disabled="saving"
                :not-found-content="grupNotFoundContent"
                @search="onGroupSearch"
                @change="onGroupChange"
              >
                <a-select-option
                  v-for="grup in groups"
                  :key="grup.id"
                  :value="grup.id"
                >
                  {{ grup.name }}
                </a-select-option>
              </a-select>
              <div v-if="grupBaruTerdeteksi" class="kontak-inline-create">
                <button
                  type="button"
                  class="kontak-inline-create-btn"
                  :disabled="creatingGroup"
                  @click.prevent="buatGrupBaru"
                >
                  <i :class="creatingGroup ? 'fa fa-spinner fa-spin' : 'fa fa-plus'"></i>
                  <span v-if="creatingGroup">Membuat grup...</span>
                  <span v-else>Buat grup baru: "{{ groupSearch.trim() }}"</span>
                </button>
              </div>
              <div v-if="groupCreateError" class="kontak-error">
                {{ groupCreateError }}
              </div>
            </div>

            <div class="form-group">
              <label>Tagging</label>
              <a-select
                v-model="selectedTagIds"
                mode="multiple"
                show-search
                allow-clear
                option-filter-prop="children"
                placeholder="Pilih Tagging"
                style="width: 100%"
                :disabled="saving"
                :not-found-content="tagNotFoundContent"
                @search="onTagSearch"
                @change="onTagChange"
              >
                <a-select-option
                  v-for="tag in tags"
                  :key="tag.id"
                  :value="tag.id"
                >
                  {{ tag.name }}
                </a-select-option>
              </a-select>
              <div v-if="tagBaruTerdeteksi" class="kontak-inline-create">
                <button
                  type="button"
                  class="kontak-inline-create-btn"
                  :disabled="creatingTag"
                  @click.prevent="buatTagBaru"
                >
                  <i :class="creatingTag ? 'fa fa-spinner fa-spin' : 'fa fa-plus'"></i>
                  <span v-if="creatingTag">Membuat tagging...</span>
                  <span v-else>Buat tagging baru: "{{ tagSearch.trim() }}"</span>
                </button>
              </div>
              <div v-if="tagCreateError" class="kontak-error">
                {{ tagCreateError }}
              </div>
              <small class="kontak-field-help">
                Tagging dapat dibuat langsung di sini dan akan tersimpan di CRM.
              </small>
            </div>
          </form>
        </div>

        <!-- ============================= AKSI MODAL ============================= -->
        <div class="kontak-modal-foot">
          <button
            type="button"
            class="btn kontak-btn kontak-btn-outline"
            :disabled="saving"
            @click="tutup"
          >
            Batal
          </button>
          <button
            type="submit"
            form="kontak-form-v2"
            class="btn kontak-btn kontak-btn-primary"
            :disabled="saving || loadingDetail || detailGagal"
          >
            <i v-if="saving" class="fa fa-spinner fa-spin"></i>
            <span v-if="saving">Menyimpan...</span>
            <span v-else>{{ isEdit ? "Simpan Perubahan" : "Simpan" }}</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ContactFormModalV2",

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: "create"
    },
    contactId: {
      type: [String, Number],
      default: ""
    },
    overlayZIndex: {
      type: [String, Number],
      default: 1040
    }
  },

  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        birth_date_data: "",
        birth_date_is_filled: 0
      },
      selectedGroupIds: [],
      selectedTagIds: [],
      initialTagIds: [],
      groups: [],
      tags: [],
      groupSearch: "",
      tagSearch: "",
      creatingGroup: false,
      creatingTag: false,
      groupCreateError: "",
      tagCreateError: "",
      loadingDetail: false,
      saving: false,
      detailGagal: false,
      errorMessage: "",
      errors: {
        first_name: "",
        phone_number: "",
        email: "",
        birth_date_data: ""
      },
      detailRequestId: 0
    };
  },

  computed: {
    isEdit() {
      return this.mode === "edit";
    },
    grupBaruTerdeteksi() {
      const query = String(this.groupSearch || "").trim().toLowerCase();
      if (!query) {
        return false;
      }
      return !this.groups.some(grup => {
        return String(grup.name || "").trim().toLowerCase() === query;
      });
    },
    tagBaruTerdeteksi() {
      const query = String(this.tagSearch || "").trim().toLowerCase();
      if (!query) {
        return false;
      }
      return !this.tags.some(tag => {
        return String(tag.name || "").trim().toLowerCase() === query;
      });
    },
    grupNotFoundContent() {
      const h = this.$createElement;
      const query = String(this.groupSearch || "").trim();

      if (!query) {
        return h(
          "div",
          { class: "kontak-inline-create is-dropdown" },
          "Tidak ada grup ditemukan."
        );
      }

      return h(
        "div",
        { class: "kontak-inline-create is-dropdown" },
        [
          h(
            "button",
            {
              class: "kontak-inline-create-btn",
              attrs: {
                type: "button",
                disabled: this.creatingGroup
              },
              on: {
                mousedown: event => {
                  event.preventDefault();
                  event.stopPropagation();
                },
                click: event => {
                  event.preventDefault();
                  event.stopPropagation();
                  this.buatGrupBaru();
                }
              }
            },
            [
              h("i", {
                class: this.creatingGroup
                  ? "fa fa-spinner fa-spin"
                  : "fa fa-plus"
              }),
              h(
                "span",
                this.creatingGroup
                  ? "Membuat grup..."
                  : 'Buat grup baru: "' + query + '"'
              )
            ]
          )
        ]
      );
    },
    tagNotFoundContent() {
      const h = this.$createElement;
      const query = String(this.tagSearch || "").trim();

      if (!query) {
        return h(
          "div",
          { class: "kontak-inline-create is-dropdown" },
          "Tidak ada tagging ditemukan."
        );
      }

      return h(
        "div",
        { class: "kontak-inline-create is-dropdown" },
        [
          h(
            "button",
            {
              class: "kontak-inline-create-btn",
              attrs: {
                type: "button",
                disabled: this.creatingTag
              },
              on: {
                mousedown: event => {
                  event.preventDefault();
                  event.stopPropagation();
                },
                click: event => {
                  event.preventDefault();
                  event.stopPropagation();
                  this.buatTagBaru();
                }
              }
            },
            [
              h("i", {
                class: this.creatingTag
                  ? "fa fa-spinner fa-spin"
                  : "fa fa-plus"
              }),
              h(
                "span",
                this.creatingTag
                  ? "Membuat tagging..."
                  : 'Buat tagging baru: "' + query + '"'
              )
            ]
          )
        ]
      );
    }
  },

  watch: {
    visible(value) {
      if (value) {
        this.inisialisasi();
      } else {
        this.detailRequestId += 1;
        this.resetForm();
      }
    }
  },

  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  },

  methods: {
    /* ============================= INISIALISASI ============================= */

    async inisialisasi() {
      this.resetForm();
      this.loadingDetail = true;
      this.detailGagal = false;
      this.detailRequestId += 1;
      const requestId = this.detailRequestId;

      try {
        await this.muatReferensi();

        if (this.isEdit && this.contactId) {
          await this.muatDetailKontak(requestId);
        }
      } catch (error) {
        if (requestId === this.detailRequestId) {
          this.detailGagal = true;
          this.errorMessage =
            "Gagal memuat data kontak. Silakan tutup modal lalu coba lagi.";
        }
      } finally {
        if (requestId === this.detailRequestId) {
          this.loadingDetail = false;
        }
      }
    },

    resetForm() {
      this.form = {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        birth_date_data: "",
        birth_date_is_filled: 0
      };
      this.selectedGroupIds = [];
      this.selectedTagIds = [];
      this.initialTagIds = [];
      this.groupSearch = "";
      this.tagSearch = "";
      this.creatingGroup = false;
      this.creatingTag = false;
      this.groupCreateError = "";
      this.tagCreateError = "";
      this.errorMessage = "";
      this.errors = {
        first_name: "",
        phone_number: "",
        email: "",
        birth_date_data: ""
      };
      this.saving = false;
      this.loadingDetail = false;
      this.detailGagal = false;
    },

    async muatReferensi() {
      // Selalu ambil data terbaru saat modal dibuka.
      await Promise.all([this.muatDaftarGrup(), this.muatDaftarTag()]);
    },

    async muatDaftarGrup() {
      try {
        const response = await this.$store.dispatch("contact/getGroupList", {
          name: "",
          page: 0,
          perPage: 1000
        });

        this.groups = (response && response.data) || [];
      } catch (error) {
        console.log(error);
        this.groups = [];
      }
    },

    async muatDaftarTag() {
      try {
        const response = await this.$store.dispatch("contact/getTagList", {
          name: "",
          page: 0,
          perPage: 1000
        });

        const payload = response.data || {};
        const daftar = payload.data || [];

        this.tags = daftar.map(tag => {
          return {
            id: tag.id,
            name: this.namaTagBersih(tag.name)
          };
        });
      } catch (error) {
        console.log(error);
        this.tags = [];
      }
    },

    onGroupSearch(query) {
      this.groupSearch = query || "";
      this.groupCreateError = "";
    },

    onTagSearch(query) {
      this.tagSearch = query || "";
      this.tagCreateError = "";
    },

    onGroupChange() {
      this.groupSearch = "";
      this.groupCreateError = "";
    },

    onTagChange() {
      this.tagSearch = "";
      this.tagCreateError = "";
    },

    tambahPilihanGrup(idGrup) {
      const sudahAda = this.selectedGroupIds.some(id => {
        return String(id) === String(idGrup);
      });

      if (!sudahAda) {
        this.selectedGroupIds.push(idGrup);
      }
    },

    tambahPilihanTag(idTag) {
      const sudahAda = this.selectedTagIds.some(id => {
        return String(id) === String(idTag);
      });

      if (!sudahAda) {
        this.selectedTagIds.push(idTag);
      }
    },

    normalisasiGrupBaru(response, namaCadangan) {
      const payload =
        response && response.data !== undefined ? response.data : response;
      const grup = Array.isArray(payload) ? payload[0] : payload;

      if (!grup) {
        return null;
      }

      return {
        ...grup,
        id: grup.id !== undefined ? grup.id : grup.Id,
        name: grup.name || grup.group_name || namaCadangan
      };
    },

    normalisasiTagBaru(response, namaCadangan) {
      const payload =
        response && response.data !== undefined ? response.data : response;
      const tag = Array.isArray(payload) ? payload[0] : payload;

      if (!tag) {
        return null;
      }

      return {
        ...tag,
        id: tag.id !== undefined ? tag.id : tag.Id,
        name: this.namaTagBersih(tag.name || namaCadangan)
      };
    },

    async buatGrupBaru() {
      const nama = String(this.groupSearch || "").trim();

      if (!nama || this.creatingGroup) {
        return;
      }

      const grupAda = this.groups.find(grup => {
        return String(grup.name || "").trim().toLowerCase() === nama.toLowerCase();
      });

      if (grupAda) {
        this.tambahPilihanGrup(grupAda.id);
        this.groupSearch = "";
        return;
      }

      this.creatingGroup = true;
      this.groupCreateError = "";

      try {
        const response = await this.$store.dispatch("contact/createGroup", {
          id: "",
          name: nama,
          description: ""
        });
        const grup = this.normalisasiGrupBaru(response, nama);

        if (!grup || grup.id === undefined || grup.id === null || grup.id === "") {
          throw new Error("ID grup baru tidak ditemukan pada respons server.");
        }

        const sudahAda = this.groups.some(item => {
          return String(item.id) === String(grup.id);
        });

        if (!sudahAda) {
          this.groups.push(grup);
        }

        this.tambahPilihanGrup(grup.id);
        this.groupSearch = "";
      } catch (error) {
        console.log(error);
        this.groupCreateError =
          "Gagal membuat grup baru. Silakan periksa nama grup lalu coba lagi.";
      } finally {
        this.creatingGroup = false;
      }
    },

    async buatTagBaru() {
      const nama = String(this.tagSearch || "").trim();

      if (!nama || this.creatingTag) {
        return;
      }

      const tagAda = this.tags.find(tag => {
        return String(tag.name || "").trim().toLowerCase() === nama.toLowerCase();
      });

      if (tagAda) {
        this.tambahPilihanTag(tagAda.id);
        this.tagSearch = "";
        return;
      }

      this.creatingTag = true;
      this.tagCreateError = "";

      try {
        const response = await this.$store.dispatch("crm/createTag", {
          id: "",
          name: nama,
          description: ""
        });
        const tag = this.normalisasiTagBaru(response, nama);

        if (!tag || tag.id === undefined || tag.id === null || tag.id === "") {
          throw new Error("ID tagging baru tidak ditemukan pada respons server.");
        }

        const sudahAda = this.tags.some(item => {
          return String(item.id) === String(tag.id);
        });

        if (!sudahAda) {
          this.tags.push(tag);
        }

        this.tambahPilihanTag(tag.id);
        this.tagSearch = "";
      } catch (error) {
        console.log(error);
        this.tagCreateError =
          "Gagal membuat tagging baru. Silakan periksa nama tagging lalu coba lagi.";
      } finally {
        this.creatingTag = false;
      }
    },

    async muatDetailKontak(requestId) {
      const response = await this.$store.dispatch(
        "contact/viewContact",
        this.contactId
      );

      if (requestId !== this.detailRequestId) {
        return;
      }

      const kontak = response.contact_list || {};
      const relasiGrup = response.contact_rel || [];
      const tanggalLahir =
        kontak.birth_date_is_filled == 1 && kontak.birth_date_data
          ? this.$moment.unix(kontak.birth_date_data).format("YYYY-MM-DD")
          : "";

      this.form = {
        first_name: kontak.first_name || "",
        last_name: kontak.last_name || "",
        email: kontak.email || "",
        phone_number:
          kontak.phone_number !== undefined && kontak.phone_number !== null
            ? String(kontak.phone_number)
            : "",
        birth_date_data: tanggalLahir,
        birth_date_is_filled: tanggalLahir ? 1 : 0
      };

      this.selectedGroupIds = Array.isArray(relasiGrup)
        ? relasiGrup.slice()
        : [];

      try {
        const tagResponse = await this.$store.dispatch(
          "crm/getTagDetailByContactId",
          { contact_id: this.contactId }
        );

        if (requestId !== this.detailRequestId) {
          return;
        }

        const daftarTag = Array.isArray(tagResponse.data)
          ? tagResponse.data
          : [];

        this.initialTagIds = daftarTag.map(tag => tag.id);
        this.selectedTagIds = this.initialTagIds.slice();
      } catch (error) {
        console.log(error);
        this.initialTagIds = [];
        this.selectedTagIds = [];
      }
    },

    /* ============================= VALIDASI ============================= */

    validasi() {
      const errors = {
        first_name: "",
        phone_number: "",
        email: "",
        birth_date_data: ""
      };

      const namaDepan = (this.form.first_name || "").trim();
      const telepon = String(this.form.phone_number || "").trim();
      const email = (this.form.email || "").trim();
      const digitTelepon = telepon.replace(/\D/g, "");

      if (!namaDepan) {
        errors.first_name = "Nama depan wajib diisi.";
      }

      if (!telepon) {
        errors.phone_number = "Nomor WhatsApp wajib diisi.";
      } else if (digitTelepon.length < 8 || digitTelepon.length > 15) {
        errors.phone_number = "Nomor WhatsApp harus terdiri dari 8–15 digit.";
      }

      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors.email = "Format email tidak valid.";
      }

      if (this.form.birth_date_data) {
        const tanggal = new Date(this.form.birth_date_data + "T00:00:00");
        const hariIni = new Date();
        hariIni.setHours(0, 0, 0, 0);

        if (isNaN(tanggal.getTime())) {
          errors.birth_date_data = "Tanggal lahir tidak valid.";
        } else if (tanggal.getTime() > hariIni.getTime()) {
          errors.birth_date_data =
            "Tanggal lahir tidak boleh melebihi hari ini.";
        }
      }

      this.errors = errors;
      return !Object.keys(errors).some(key => errors[key] !== "");
    },

    /* ============================= SIMPAN ============================= */

    simpan() {
      if (this.saving || this.loadingDetail || this.detailGagal) {
        return;
      }

      if (!this.validasi()) {
        return;
      }

      this.errorMessage = "";
      this.saving = true;

      if (this.isEdit) {
        this.simpanPerubahan();
      } else {
        this.simpanKontakBaru();
      }
    },

    buatPayloadKontak() {
      return {
        first_name: (this.form.first_name || "").trim(),
        last_name: (this.form.last_name || "").trim(),
        email: (this.form.email || "").trim(),
        phone_number: String(this.form.phone_number || "").trim(),
        list_id: this.selectedGroupIds.map(idGrup => {
          return { id: idGrup };
        }),
        birth_date_data: this.form.birth_date_data || "",
        birth_date_is_filled: this.form.birth_date_data ? 1 : 0
      };
    },

    async simpanKontakBaru() {
      try {
        const payload = this.buatPayloadKontak();
        const response = await this.$store.dispatch(
          "contact/createContact",
          payload
        );

        const idKontak =
          response && (response.id || response.Id) ? response.id || response.Id : "";
        let peringatan = "";

        if (this.selectedTagIds.length) {
          if (!idKontak) {
            peringatan =
              "Kontak berhasil ditambahkan, tetapi tagging gagal disimpan.";
          } else {
            try {
              await this.simpanTagBaru(idKontak);
            } catch (error) {
              console.log(error);
              peringatan =
                "Kontak berhasil ditambahkan, tetapi tagging gagal disimpan.";
            }
          }
        }

        this.saving = false;
        this.$emit("saved", {
          mode: "create",
          warning: peringatan,
          contact: response || payload
        });
      } catch (error) {
        console.log(error);
        this.saving = false;
        this.errorMessage = this.pesanGagal(error);
      }
    },

    async simpanPerubahan() {
      try {
        const payload = Object.assign({}, this.buatPayloadKontak(), {
          id: this.contactId
        });

        const response = await this.$store.dispatch(
          "contact/updateContact",
          payload
        );

        let peringatan = "";

        try {
          await this.sinkronkanTag();
        } catch (error) {
          console.log(error);
          peringatan =
            "Perubahan kontak berhasil disimpan, tetapi tagging gagal disimpan.";
        }

        this.saving = false;
        this.$emit("saved", {
          mode: "edit",
          warning: peringatan,
          contact: response || payload
        });
      } catch (error) {
        console.log(error);
        this.saving = false;
        this.errorMessage = this.pesanGagal(error);
      }
    },

    simpanTagBaru(idKontak) {
      if (!this.selectedTagIds.length) {
        return Promise.resolve();
      }

      return this.$store.dispatch("crm/assignContactToTag", {
        id: idKontak,
        tag_id: this.selectedTagIds.slice()
      });
    },

    async sinkronkanTag() {
      const tagAwal = this.initialTagIds.slice();
      const tagDipilih = this.selectedTagIds.slice();

      const tagDihapus = tagAwal.filter(idTag => {
        return tagDipilih.indexOf(idTag) === -1;
      });

      const tagDitambah = tagDipilih.filter(idTag => {
        return tagAwal.indexOf(idTag) === -1;
      });

      if (tagDihapus.length) {
        await Promise.all(
          tagDihapus.map(idTag => {
            return this.$store.dispatch("crm/unassignFromOneTag", {
              contact_id: this.contactId,
              tag_id: idTag
            });
          })
        );
      }

      if (tagDitambah.length) {
        await this.$store.dispatch("crm/assignContactToTag", {
          id: this.contactId,
          tag_id: tagDitambah
        });
      }
    },

    /* ============================= PESAN & UTILITAS ============================= */

    pesanGagal(error) {
      const pesanDasar =
        "Gagal menyimpan data kontak. Periksa kembali input Anda.";
      const detail = this.ambilPesanError(error);

      if (!detail || detail === "Error") {
        return pesanDasar;
      }

      const terjemahan = this.terjemahkanPesanError(detail);
      return pesanDasar + " " + (terjemahan || detail);
    },

    ambilPesanError(error) {
      if (!error) {
        return "";
      }

      let pesan = "";

      if (error.message) {
        pesan = String(error.message);
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.msg
      ) {
        pesan = String(error.response.data.msg);
      }

      return pesan
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<[^>]*>/g, "")
        .trim();
    },

    terjemahkanPesanError(pesan) {
      const teks = String(pesan).toLowerCase();

      if (teks.indexOf("phone number is required") !== -1) {
        return "Nomor WhatsApp wajib diisi.";
      }

      if (teks.indexOf("phone number is already exist") !== -1) {
        return "Nomor WhatsApp sudah terdaftar.";
      }

      if (teks.indexOf("birthday date is required") !== -1) {
        return "Tanggal lahir wajib diisi.";
      }

      if (teks.indexOf("birthday dates do not match") !== -1) {
        return "Tanggal lahir tidak valid.";
      }

      if (teks.indexOf("contact id is required") !== -1) {
        return "ID kontak tidak ditemukan.";
      }

      if (teks.indexOf("contact id is not found") !== -1) {
        return "Data kontak tidak ditemukan.";
      }

      if (teks.indexOf("tag id is required") !== -1) {
        return "Tagging wajib dipilih.";
      }

      if (teks.indexOf("tag id is not found") !== -1) {
        return "Data tagging tidak ditemukan.";
      }

      return "";
    },

    namaTagBersih(nama) {
      return String(nama || "").replace(/\s~\s\d+$/, "");
    },

    tutup() {
      if (this.saving) {
        return;
      }

      this.detailRequestId += 1;
      this.$emit("close");
    },

    handleKeydown(event) {
      if (event.key === "Escape" && this.visible) {
        this.tutup();
      }
    }
  }
};
</script>

<style scoped>
.kontak-modal-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  overflow-y: auto;
  background: rgba(15, 23, 42, 0.5);
}

.kontak-modal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 650px;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.26);
}

.kontak-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-bottom: 1px solid #eef2f7;
}

.kontak-modal-head h5 {
  margin: 0;
  color: #101828;
  font-size: 17px;
  font-weight: 700;
}

.kontak-modal-head p {
  margin: 4px 0 0;
  color: #667085;
  font-size: 12px;
}

.kontak-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  padding: 0;
  color: #667085;
  background: #ffffff;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  font-size: 12px;
  cursor: pointer;
}

.kontak-close:hover:not(:disabled) {
  color: #b42318;
  background: #fef3f2;
  border-color: #fecdca;
}

.kontak-close:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.kontak-modal-body {
  padding: 18px 20px;
  overflow-y: auto;
}

.kontak-modal-foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 20px;
  background: #fbfcfe;
  border-top: 1px solid #eef2f7;
}

.kontak-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 180px;
  color: #667085;
  font-size: 13px;
}

.kontak-loading i {
  color: #f39c12;
}

.kontak-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 15px;
  color: #912018;
  background: #fef3f2;
  border: 1px solid #fecdca;
  border-radius: 10px;
  font-size: 12px;
  line-height: 1.5;
}

.kontak-alert i {
  margin-top: 2px;
  color: #d92d20;
}

.kontak-required {
  color: #d92d20;
}

.kontak-error {
  margin-top: 4px;
  color: #b42318;
  font-size: 11px;
}

.kontak-field-help {
  display: block;
  margin-top: 5px;
  color: #98a2b3;
  font-size: 11px;
  line-height: 1.45;
}

.kontak-inline-create {
  margin-top: 7px;
}

.kontak-inline-create.is-dropdown {
  padding: 5px 8px 8px;
  margin-top: 0;
  color: #98a2b3;
  font-size: 11px;
  line-height: 1.4;
}

.kontak-inline-create-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 30px;
  padding: 5px 11px;
  color: #b36b00;
  background: #fffaf1;
  border: 1px dashed #f6c26b;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.3;
  text-align: left;
  transition: background-color 0.18s ease, border-color 0.18s ease;
}

.kontak-inline-create-btn:hover:not(:disabled) {
  background: #fff3df;
  border-color: #f39c12;
}

.kontak-inline-create-btn:disabled {
  cursor: wait;
  opacity: 0.65;
}

.kontak-modal .form-group > label {
  margin-bottom: 6px;
  color: #344054;
  font-size: 12px;
  font-weight: 600;
}

.kontak-modal .form-control {
  height: 40px;
  color: #344054;
  border: 1px solid #d8e1ee;
  border-radius: 9px;
  font-size: 13px;
}

.kontak-modal .form-control:focus {
  border-color: #f6c26b;
  box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.14);
}

.kontak-modal .form-control.is-invalid {
  border-color: #fda29b;
  background: #fffbfa;
}

.kontak-modal .form-group .row > [class*="col-"] {
  margin-bottom: 8px;
}

.kontak-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 40px;
  padding: 0 18px;
  border: 1px solid transparent;
  border-radius: 9999px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease;
}

.kontak-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.22);
}

.kontak-btn:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.kontak-btn-primary {
  color: #ffffff;
  background-color: #f39c12;
  border-color: #f39c12;
  font-weight: 700;
  box-shadow: 0 7px 16px rgba(243, 156, 18, 0.24);
}

.kontak-btn-primary:hover:not(:disabled),
.kontak-btn-primary:focus:not(:disabled) {
  color: #ffffff;
  background-color: #e08e0b;
  border-color: #e08e0b;
}

.kontak-btn-outline {
  color: #555555;
  background-color: #ffffff;
  border-color: #d1d5db;
}

.kontak-btn-outline:hover:not(:disabled),
.kontak-btn-outline:focus:not(:disabled) {
  color: #444444;
  background-color: #f9fafb;
  border-color: #b9bec7;
}

.kontak-fade-enter-active,
.kontak-fade-leave-active {
  transition: opacity 0.18s ease;
}

.kontak-fade-enter,
.kontak-fade-leave-to {
  opacity: 0;
}

@media (max-width: 575px) {
  .kontak-modal-overlay {
    padding: 10px;
  }

  .kontak-modal {
    max-height: calc(100vh - 20px);
  }

  .kontak-modal-head,
  .kontak-modal-body,
  .kontak-modal-foot {
    padding-left: 15px;
    padding-right: 15px;
  }

  .kontak-modal-foot {
    flex-direction: column-reverse;
  }

  .kontak-modal-foot .kontak-btn {
    width: 100%;
  }
}
</style>

<style>
/* Penyesuaian komponen Ant Design Select agar sesuai brand Waajo. */
.kontak-modal .ant-select-selection {
  min-height: 40px;
  border: 1px solid #d8e1ee;
  border-radius: 9px;
}

.kontak-modal .ant-select-selection:hover {
  border-color: #f6c26b;
}

.kontak-modal .ant-select-selection:focus,
.kontak-modal .ant-select-selection:active {
  border-color: #f6c26b;
  box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.14);
}

.kontak-modal .ant-select-selection--multiple {
  padding-bottom: 2px;
}

.kontak-modal .ant-select-selection__choice {
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 20px;
}

.kontak-modal .ant-select-selection__choice__remove {
  color: #b36b00;
}
</style>



// WEBPACK FOOTER //
// src/views/contacts/ContactFormModalV2.vue